/**
 * User Icon Renderer - AD user node icon
 *
 * Renders a stylised person silhouette inside the standard circular badge.
 */

import { getIconConfig } from '@/components/icons/nodeIcons/config/iconConfig';
import { getThemeColors } from '@/components/icons/nodeIcons/config/themeColors';
import {
  calculateIconPosition,
  drawCircleBackground,
  setupCanvas,
} from '@/components/icons/nodeIcons/renderers/base';

export const createUserIconDataURL = (
  currentTheme: 'light' | 'dark',
  isHighlighted: boolean = false
): string => {
  const config = getIconConfig('user');
  const colors = getThemeColors('user', currentTheme, isHighlighted);
  const { canvas, ctx, size, centerX, centerY } = setupCanvas(config);

  drawCircleBackground(ctx, centerX, centerY, size, config.scale, colors);

  const { x, y, scale } = calculateIconPosition(centerX, centerY, size, config);

  ctx.save();
  ctx.translate(x, y);
  ctx.scale(scale, scale);
  ctx.fillStyle = colors.icon;

  const personPath = new Path2D(
    'M4,20 C4,17 8,17 10,15 C11,14 8,14 8,9 C8,5.667 9.333,4 12,4 C14.667,4 16,5.667 16,9 C16,14 13,14 14,15 C16,17 20,17 20,20'
  );

  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.lineWidth = 1.5;
  ctx.strokeStyle = colors.icon;
  ctx.stroke(personPath);

  ctx.restore();

  return canvas.toDataURL('image/png', 1.0);
};
